// src/app/app.routing.ts
import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './guards/authGuard.service';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'sifac',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./components/sifac/sifac.routing').then(m => m.SIFAC_ROUTES),
  },
  // Si quieres proteger 'impresion', define una ruta específica protegida
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./components/impresion/impresion.routing').then(m => m.IMPRESION_ROUTES),
  },
  {
    path: '**',
    redirectTo: 'permiso-denegado'
  }
];
